// extracted by mini-css-extract-plugin
module.exports = {"container":"VerticalPopularRequestItem_container__gi7F3","pro-card-container":"VerticalPopularRequestItem_pro-card-container__Eb_08"};